// import SignInForm from "./components/SignInForm";
// import ForgotPasswordForm from "./components/ForgotPasswordForm";
import { useState } from "react";
import AuthForm from "./components/auth-form";
import AuthLayout from "./layout/AuthLayout";
import ForgotPasswordForm from "./components/forgot-password-form";

function AuthenticationPage() {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  return (
    <AuthLayout>
      {!showForgotPassword ? (
        <AuthForm onForgotPasswordClick={() => setShowForgotPassword(true)} />
      ) : (
        <ForgotPasswordForm onGoBack={() => setShowForgotPassword(false)} />
      )}
    </AuthLayout>
  );
}

export default AuthenticationPage;
